/**
 * TeamChip
 *
 * A small club-colour pill (abbreviation only). Extracted out of
 * InjuryInsurance.jsx and ScheduleSurgeon.jsx, which both defined this
 * verbatim, hardcoded to `teamColor(abbr, 'nba')` — meaning an NFL league
 * on either page resolved every chip to the fallback colour instead of
 * that club's real one. `sport` is now a required-in-spirit prop so a
 * caller has to say which colour table to resolve against.
 *
 * Background is always the club's primary colour; text is the club's
 * secondary colour, unless secondary-on-primary fails WCAG contrast, in
 * which case it falls back to the precomputed `ink` (see
 * teamChipStyle() in config/teamColors.js — computed, not hand-maintained).
 *
 * Props:
 *   abbr   — club abbreviation, e.g. 'BOS' or 'SF'
 *   sport  — 'nba' | 'nfl' (default 'nba')
 */

import { teamChipStyle } from '../config/teamColors'

export default function TeamChip({ abbr, sport = 'nba' }) {
  if (!abbr) return null
  const style = teamChipStyle(abbr, sport)
  return (
    <span style={{ fontSize: 10, fontWeight: 700, color: style.color, background: style.background, borderRadius: 999, padding: '2px 8px', flexShrink: 0 }}>
      {abbr}
    </span>
  )
}
